module.exports = __webpack_public_path__ + "img/case-bg-5.e466a9cf.png";